/**
 * One named lane of the hour chart: its word on the left (Score, Visits,
 * Rules, Drops, the clocks), the 24 hours on the right — so every mark on
 * the chart says what it is without a legend hunt.
 * For Media Devoted | Created By Ciro Autiero
 */
import { CSSProperties, FC, ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

import { cn } from '@/lib/utils';

/** 24 equal columns — every lane lines up hour for hour. */
export const HOUR_GRID: CSSProperties = { gridTemplateColumns: 'repeat(24, minmax(0, 1fr))' };

interface Props {
  icon?: LucideIcon;
  label?: ReactNode;
  /** What the lane shows, on hover of its name. */
  title?: string;
  className?: string;
  children: ReactNode;
}

export const ChartLane: FC<Props> = ({ icon: Icon, label, title, className, children }) => (
  <div className="flex items-stretch gap-2">
    <span className="flex w-[64px] shrink-0 items-center gap-1.5 whitespace-nowrap text-[11px] font-medium text-muted-foreground" title={title}>
      {Icon ? <Icon className="h-3.5 w-3.5 shrink-0" aria-hidden /> : null}
      {label}
    </span>
    <div className={cn('relative min-w-0 flex-1', className)}>{children}</div>
  </div>
);
